import { StyleSheet } from 'aphrodite';
import { absoluteCenterStyle } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		justifyContent: 'center',
	},
	infoText: {
		color: '#4a4a4a',
		fontSize: 14,
		lineHeight: '30px',
		marginTop: 30,
		textAlign: 'center',
	},
	spinnerContainer: {
		...absoluteCenterStyle,
	},
});
